export default "__VITE_ASSET__DgZgoBLe__"